const draggableClasses = {
  draggable: 'draggable',
  sortable: 'sortable',
  active: 'active',
  moving: 'moving',
  drop: 'drop',
  body: 'draggable-active',
  handle: 'draggable-handle',
  placeholder: 'draggable-placeholder',
  background: 'draggable-background',
  item: 'draggable-item',
  itemActive: 'draggable-item-active'
};

export {draggableClasses};
